import React from 'react';
import styled, { css } from 'styled-components';
import { gridColumns, gridRow, gridSpan } from '@zimpel/common/components/Grid';
import type { PropsWithChildren } from 'react';

const StyledContentContainer = styled.div<{ $isDisabled?: boolean }>`
  width: var(--content-width);
  display: flex;
  flex-direction: column;
  ${({ $isDisabled }) => $isDisabled && css`
    user-select: none;
  `}
`;

const StyledDarkOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 20%);
  z-index: 1;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
`;

const ContentContainer: React.FC<PropsWithChildren & {
  isDisabled?: boolean, onBackgroundClick?: () => void
}> = ({ children, isDisabled, onBackgroundClick }) => (
  <StyledContentContainer $isDisabled={isDisabled}>
    {children}
    {isDisabled && <StyledDarkOverlay onClick={onBackgroundClick} />}
  </StyledContentContainer>
);

const ContentHeader = styled.header`
  padding-left: ${gridColumns(1)};
  box-sizing: border-box;
  align-items: baseline;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: var(--border-box);
  ${gridRow};
`;

const ContentNarrow = styled.div`
  ${gridSpan(12)};
`;

const ContentWide = styled.div`
  ${gridSpan(19)};
`;

const ContentBody = styled.div`
  ${gridRow};
  padding-left: ${gridColumns(1)};
  box-sizing: border-box;
  padding-top: 30px;
  padding-bottom: 60px;
`;

const ContentAside = styled.aside<{ $isScrollable?: boolean }>`
  ${gridSpan(6)};
  margin-left: ${gridColumns(1)};
  position: sticky;
  top: calc(var(--app-header-height) + 10px);
  align-self: flex-start;
  ${({ $isScrollable }) => ($isScrollable ? css`
    overflow-y: auto;
    max-height: calc(100vh - 20px);
  ` : css`
    height: auto;
  `)}
`;

export {
  ContentContainer,
  ContentHeader,
  ContentBody,
  ContentNarrow,
  ContentWide,
  ContentAside,
};
